import Component, { mixins, createDecorator } from "vue-class-component";
import ABaseComponent from "Components/Base/ABaseComponent";
import { Mixins, Prop } from "vue-property-decorator";
import { ProductListComponent } from "..";
import { Pagination } from "Models/Products/ProductListPage";
import Vue from 'vue';
import productList from "Store/productList/productList";
import { FilterItem } from "Models/FacetFilter/FilterItem";

@Component({})
export class PaginationComponent extends ABaseComponent{
    @Prop({required: true})
    public pagination: Pagination;

    @Prop({default:""})
    currentPageLink:string

    togglePage(pageNumber:number){
        let filterItems:FilterItem[] = new Array();
        const pageNum = new FilterItem("PageNum",(pageNumber).toString());
        const pageSize = new FilterItem("PageSize",this.pageSize.toString());
        filterItems.push(pageNum);
        filterItems.push(pageSize);
        productList.dispatchUpdateQueryReplaceValues(filterItems);
    }

    toggleNextPage():void{
        this.togglePage(this.currentPage+1);
    }
    togglePrevPage():void{
        this.togglePage(this.currentPage-1);
    }

    get currentPage():number{
        return this.pagination.currentPage;
    }

    get pageSize():number{
        return this.pagination.pageSize;
    }

    get totalPages():number{
        return this.pagination.totalPages;
    }

    get hasGroupId():boolean{
        return this.pagination.hasGroupIdQuery;
    }
    
}
Vue.component("pagination",PaginationComponent)